import type { IconData } from '@stacksjs/iconify-core'

export const spaceKey: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 15H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 2 0v3h16v-3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default spaceKey
